import { getSiteConfigByHostname } from '@alexis/helpers/site';
import { locales } from '@alexis/helpers/site';
import cookies from 'js-cookie';

import { WEGO_LOCALE_COOKIE_KEY } from '@constants/cookie';

import { isGoogleBot } from './bots';

const isLocale = (str: string) => locales.find((locale) => locale.code === str);

// List of languages supported by WegoPro
const SUPPORTED_WEGOPRO_LOCALES = ['ar', 'id', 'ja', 'ko', 'th', 'vi', 'zh', 'zht', 'en'];

export const getWegoProUrl = (locale: string, params?: string): string => {
  // Map Wego locale codes to WegoPro locale codes if needed
  const localeMapping: Record<string, string> = {
    'zh-cn': 'zh',
    'zh-tw': 'zht',
    'zh-hk': 'zht',
  };

  const wegoProLocale = localeMapping[locale] || locale;

  const isSupportedLocale = SUPPORTED_WEGOPRO_LOCALES.includes(wegoProLocale);

  const normalizedLocale = isSupportedLocale ? wegoProLocale : 'en';

  return `https://www.wegopro.com/${normalizedLocale}/wego-for-business${
    params ? `?${params}` : ''
  }`;
};

export const isRtl = (locale: string) => /(?:fa|ar)/i.test(locale);

export const getLocaleParam = (pathname = window.location.pathname) => {
  const firstSegment = pathname?.split('/')[1];

  return isLocale(firstSegment) ? firstSegment : undefined;
};

export const getLocaleSearchParam = (
  searchParams = new URLSearchParams(window.location.search),
) => {
  const ulangSearchParam = searchParams.get('ulang');

  if (ulangSearchParam && isLocale(ulangSearchParam)) return ulangSearchParam;
};

const getLocaleCookie = () => {
  const localeCookie = cookies.get(WEGO_LOCALE_COOKIE_KEY) || '';

  return isLocale(localeCookie) ? localeCookie : undefined;
};

export const getPreferredLocale = (pathname = window.location.pathname) => {
  const localeCookie = getLocaleCookie();
  const currentSite = getSiteConfigByHostname(window.location.hostname);

  if (localeCookie) {
    return localeCookie;
  }

  if (
    currentSite.countryCode === 'AE' &&
    !isGoogleBot &&
    !/^ar\b/.test(navigator.language) &&
    !['/hotels', '/flights', '/car-rentals'].includes(pathname)
  ) {
    return 'en';
  }
};

export const getInitialLocale = () => {
  const localeParam = getLocaleParam();
  const localeSearchParam = getLocaleSearchParam();
  const preferredLocale = getPreferredLocale();
  const currentSite = getSiteConfigByHostname(window.location.hostname);

  const urlLocale = localeSearchParam || localeParam;

  if (urlLocale) return urlLocale;

  return preferredLocale || currentSite.defaultLocale;
};
